export default __webpack_public_path__ + "static/media/w.5d239173.mp4";